// Utility to resolve the fullest patient name consistently across PDFs and jsPDF letters
export const getFullPatientName = (application) => {
  if (!application) return 'Patient';
  const p = application.patient || {};
  const candidates = [
    p.fullName,
    p.originalName,
    p.completeName,
    p.displayName,
    p.legalName,
    p.name,
    application.policyHolder?.name
  ].filter(v => typeof v === 'string' && v.trim().length > 0);
  if (!candidates.length) return 'Patient';
  const longest = candidates.reduce((a,b) => (b.trim().length > a.trim().length ? b : a));
  return longest.replace(/\s+/g,' ').trim();
};

export default getFullPatientName;
